import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import '@mdi/font/css/materialdesignicons.css'
import Key from '@/components/Icons/Key'
import Person from '@/components/Icons/Person'

Vue.use(Vuetify)

const opts = {
    icons: {
        iconfont: 'mdi',
        values: {
            key: {
                component: Key
            },
            person: {
                component: Person
            }
        }
    }
}


export default new Vuetify(opts)